import styled from 'styled-components';

const PageHeaderWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 20rem;
  grid-template-rows: auto auto;
  grid-auto-flow: column;

  grid-column-gap: ${(props): string => props.theme.spaces.xl};

  div:nth-child(3) {
    grid-row: 1 / -1;
    display: flex;
    align-items: center;
  }
`;

export { PageHeaderWrapper };
